/** Blur focused number inputs on wheel so scroll does not change their value. */
export const setupDisableNumberInputScroll = () => {
  window.addEventListener(
    'wheel',
    () => {
      const { activeElement } = document;
      if (activeElement instanceof HTMLInputElement && activeElement.type === 'number') {
        activeElement.blur();
      }
    },
    { passive: true },
  );
};

export const numberInputProps = {
  onWheel: (event) => event.currentTarget.blur(),
};
